import axios from '../../../axios';
import IJobConsultantInteractionDTO from '../types/IJobConsultantInteractionDTO';

const url = '/consultants/api/job-consultant-interaction';

export const bulkEmailToJobPosters = (payload: IJobConsultantInteractionDTO) =>
  axios.post(url, payload);

export const getJobOwnersWhoBlockedRecruiter = (recruiterId: string) =>
  axios.get(`${url}/find-jobOwners-who-blocked-this-recruiter?recruiterId=${recruiterId}`);
